import type { DemoScript } from "../types.js";

/**
 * Settings → Tasks › subtask completion roll-up: two-way (all children done →
 * parent completes) vs parent→children (completing the parent cascades down).
 * The rollup mode is PINNED via settings() — under "ask", complete() would
 * await a confirm dialog the demo stage never mounts.
 */
export const settingSubtaskRollup: DemoScript = {
  id: "setting-subtask-rollup",
  titleKey: "demos.title.subtaskRollup",
  view: { kind: "days", count: 3 },
  stage: { width: 960, height: 600 },
  settings: async (ctx) => {
    await ctx.stores.settings.setSubtaskRollup("two_way");
  },
  fixture: [
    { ref: "renovation", titleKey: "demos.fx.renovation", dayOffset: 1, hour: 10, durationMin: 120 },
    { ref: "paint", titleKey: "demos.fx.paint", dayOffset: 0, subtaskOf: "renovation" },
    { ref: "floor", titleKey: "demos.fx.orderFloor", dayOffset: 0, subtaskOf: "renovation" },
  ],
  steps: [
    { kind: "caption", key: "demos.cap.rollup.twoWay" },
    { kind: "moveTo", target: { kind: "subtaskRow", ref: "paint" } },
    { kind: "press" },
    { kind: "release" },
    { kind: "action", run: (ctx) => ctx.stores.tasks.complete(ctx.id("paint"), true) },
    { kind: "moveTo", target: { kind: "subtaskRow", ref: "floor" } },
    { kind: "press" },
    { kind: "release" },
    {
      kind: "action",
      run: (ctx) => ctx.stores.tasks.complete(ctx.id("floor"), true),
      captionKey: "demos.cap.rollup.childrenDone",
    },
    { kind: "pause", ms: 1000 },
    {
      kind: "action",
      run: async (ctx) => {
        await ctx.stores.tasks.complete(ctx.id("renovation"), false);
        await ctx.stores.settings.setSubtaskRollup("parent_to_children");
      },
      captionKey: "demos.cap.rollup.parentMode",
    },
    { kind: "moveTo", target: { kind: "taskTitle", ref: "renovation" } },
    { kind: "press" },
    { kind: "release" },
    {
      kind: "action",
      run: (ctx) => ctx.stores.tasks.complete(ctx.id("renovation"), true),
      captionKey: "demos.cap.rollup.parentDone",
    },
    { kind: "pause", ms: 1000 },
  ],
};
